import { ShowWhenTrue } from "@/components/conditionals"
import { Button } from "@/components/button"
import { formatCurrency } from "@/domains/library"
import { cn } from "@/domains/library"

import type { IRevenueSourceCard } from "./types"

interface VoteInputColumnProps {
  revenueSource: IRevenueSourceCard
  totalUsed: number
  onUpdateAllocation: (id: string, value: number) => void
}

export const VoteInputColumn = ({ revenueSource, totalUsed, onUpdateAllocation }: VoteInputColumnProps) => {
  const available = Math.max(0, 100 - totalUsed)

  const handleMax = () => {
    const maxPossible = Math.min(100, revenueSource.allocation + available)
    onUpdateAllocation(revenueSource.id, maxPossible)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let num = parseInt(e.target.value, 10)
    if (Number.isNaN(num)) num = 0
    if (num > 100) num = 100
    if (num < 0) num = 0
    onUpdateAllocation(revenueSource.id, num)
  }

  const lastEpochVoteCount = revenueSource.lastEpochVoteCount

  return (
    <div className="flex flex-col items-end justify-end gap-1">
      <div className="grid grid-cols-2 gap-x-2 gap-y-1">
        <div>
          <input
            type="number"
            min="0"
            max="100"
            value={revenueSource.allocation > 0 ? revenueSource.allocation : ""}
            onChange={handleInputChange}
            placeholder="0"
            className={cn(
              "h-[32px] w-[60px] rounded border bg-p500 px-2 text-right text-sm font-bold text-t100 outline-none",
              "border-p400-light focus:border-primary-400",
              "[-moz-appearance:textfield] placeholder:text-t300",
              "[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
            )}
          />
        </div>
        <Button
          variant="percentage"
          className="h-[32px] px-2 py-1 text-[10px] font-bold uppercase"
          onClick={handleMax}
        >
          Max
        </Button>
        <div className="col-span-2 flex flex-col text-xs text-t200">
          <ShowWhenTrue when={lastEpochVoteCount > 0}>
            <p className="italic text-t300">{formatCurrency(lastEpochVoteCount, 0)} last epoch</p>
          </ShowWhenTrue>
        </div>
      </div>
    </div>
  )
}
